import { Component, computed, Signal } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog } from '@app/core/classes/dialog';
import { IconComponent } from '../icon';

export interface ConfirmationDialogProps {
  title: string;
  message: string;
  isMessageTranslated?: boolean;
  messageAlignment?: CSSStyleDeclaration['textAlign'];
  cancelText?: string;
  hideCancel?: boolean;
  confirmText?: string;
  icon?: string;
  isDangerous?: boolean;
  listItems?: string[];
  disableConfirm?: Signal<boolean>;
}

@Component({
    selector: 'topo-confirmation-dialog',
    imports: [DialogComponent, IconComponent],
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent extends Dialog<ConfirmationDialogProps> {
  protected props = this.data;

  title = computed(() => {
    const { title } = this.props;

    if (!title) {
      return;
    }

    return this.translate.instant(title);
  });

  message = computed(() => {
    const { message, isMessageTranslated = false } = this.props;

    if (!message) {
      return;
    }

    if (isMessageTranslated) {
      return message;
    }

    return this.translate.instant(message);
  });

  messageAlignment = this.props?.messageAlignment ?? 'left';

  confirmBtnText = computed(() => {
    const { confirmText = 'COMMON.YES' } = this.props;
    return this.translate.instant(confirmText);
  });

  cancelBtnText = computed(() => {
    const { cancelText = 'COMMON.NO' } = this.props;
    return this.translate.instant(cancelText);
  });

  confirmBtnClass = computed(() => `button is-medium ${this.props.isDangerous ? 'is-danger' : 'is-primary'}`);

  disableConfirm = computed(() => {
    const { disableConfirm } = this.props;
    return !!disableConfirm ? disableConfirm() : false;
  });
}
